import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DatePipe } from '@angular/common';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { ToastrModule } from 'ngx-toastr';
import { ErrorHandlerDirective } from './directives/error-handler.directive';
import { authInterceptorProviders } from './auth.interceptor';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { CommonRestService } from './services/CommonRest.service';
import { BusinessCommonService } from './services/business-common.service';
import { HttpInterceptorService } from './core/interceptor/httpinterceptor-service';
import { LoaderComponent } from '@ace/ace';
import { CookieService } from 'ngx-cookie-service';
import { ExportCardComponent } from '@ace/ace';
import { NotificationsComponent } from '@ace/ace';
import { SecurityModule } from '@ace/ace';
import { ACE_MAIN_NAV_PAGES, APP_ENVIRONMENT, TranslationService } from '@ace/ace';
import { LocalTranslationService } from './services/local-translation.service';
import mainPages from './config/main-pages.json';
import { environment } from '../environments/environments';

export function HttpLoaderFactory(http: HttpClient) {
  const langPath = "./assets/i18n/";
  return new TranslateHttpLoader(http, langPath, '.json');
}
@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    FormsModule,
    BrowserModule,
    AppRoutingModule,
    NotificationsComponent,
    BrowserAnimationsModule,
    ToastrModule.forRoot(),
    TranslateModule.forRoot({
      defaultLanguage: 'en',
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    TranslateModule,
    LoaderComponent,
    ExportCardComponent,
    SecurityModule
  ],
  providers: [
    authInterceptorProviders,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpInterceptorService,
      multi: true,
    },
    CommonRestService,
    BusinessCommonService,
    CookieService,
    ErrorHandlerDirective,
    { provide: APP_ENVIRONMENT, useValue: environment },
    { provide: ACE_MAIN_NAV_PAGES, useValue: mainPages },
    { provide: TranslationService, useClass: LocalTranslationService },
    DatePipe,
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimationsAsync()],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent]
})
export class AppModule { }
